
import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faFilter, faSearch } from '@fortawesome/free-solid-svg-icons'

import moment from 'moment'
import Checkbox from '@mui/material/Checkbox'
import FormControlLabel from '@mui/material/FormControlLabel'
import Switch from '@mui/material/Switch'
import { useMatomo } from '@jonkoops/matomo-tracker-react'

import React, { Fragment as F, useContext, useEffect, useRef, useState } from 'react'
import Modal from 'react-modal'
import Select from 'react-select'
import Reorder, { reorder } from 'react-reorder'
import {
  Link,
  useParams,
} from "react-router-dom"
import { toast } from 'react-toastify'

import {
  SchedulesCtx,
} from '../schedules'
import {
  useApiRouter,
  appRouter,
  C,
  logg,
} from '$shared'



import {
  AppCtx,
} from '$src/App'

import {
  PeriodsCtx,
} from '$src/components/periods'
import {
  // AdvancedReportLineitem,
  AddLineitemsModal,
  ReportsCtx,
} from '.'

library.add( faFilter, faSearch )


/**
 * AdvancedReportEditModal
**/
const AdvancedReportEditModal = (props) => {
  // logg(props, 'AdvancedReportEditModal')

  const apiRouter = useApiRouter()
  const { trackPageView, trackEvent } = useMatomo()

  /* ctx */

  const {
    report_id,
  } = useParams()
  // logg(useParams(), 'params in AdvancedReportEditModal')

  const {
    setLoading,
  } = useContext(AppCtx)

  const {
    periodsList,
    relativeToAbsolute,
  } = useContext(PeriodsCtx)

  const {
    advancedReportsList, refreshAdvancedReportsList,
    allUbprCodes,
    reportsList, refreshReportsList,
    advancedReportEditModalOpen,  setAdvancedReportEditModalOpen,
  } = useContext(ReportsCtx)
  logg(useContext(ReportsCtx), 'ReportsCtx in AdvancedReportEditModal')

  const {
    schedulesList,
  } = useContext(SchedulesCtx)
  // logg(useContext(SchedulesCtx), 'SchedulesCtx in AdvancedReportEditModal')


  /* state */

  const [ modalTitle, setModalTitle ] = useState('New Multi Fi Report')
  const [ selectedSchedule, setSelectedSchedule ] = useState(null)
  const [ showAddLineitems, setShowAddLineitems ] = useState(false)

  let [ ubprsList, setUbprsList ] = useState([])
  const [ ubprsListFilter, setUbprsListFilter ] = useState('')
  const [ filteredUbprsList, setFilteredUbprsList ] = useState([])
  const [ eol, setEol ] = useState(null)
  const [ reportName, setReportName ] = useState('')
  const [ lineitems, setLineitems ] = useState([])


  /* effects */

  /* select a schedule */
  useEffect(() => {
    if (selectedSchedule) {
      setLoading(true)
      fetch(apiRouter.ubprCodesPath({ schedule_id: selectedSchedule })).then(r => r.json()).then(inns => {
        // logg(inns, `ubprCodes of schedule ${selectedSchedule}`)
        setUbprsList(inns)
        setFilteredUbprsList(inns)
        setLoading(false)
      })
    } else {
      // logg(allUbprCodes, 'allUbprCodes')
      setUbprsList(allUbprCodes)
    }
  }, [ selectedSchedule, allUbprCodes ])


  /* load a report */
  useEffect(() => {
    if (report_id) {
      setLoading(true)
      setAdvancedReportEditModalOpen(true)
      fetch(apiRouter.advancedReportPath({ id: report_id })).then(r => r.json()).then(inns => {
        // logg(inns, 'fetched report')
        setModalTitle('Edit Multi Fi Report')
        setReportName(inns.report.name)
        setLineitems(inns.report.lineitems)
        logg(inns.report.lineitems, 'herehere')
        setLoading(false)
      })
    }
  }, [ report_id ] )

  useEffect(() => {
    // trackPageView()
    trackEvent({ category: 'AdvancedReportEditModal', action: 'show' })
  }, [ advancedReportEditModalOpen ])

  /* methods */

  const handleClear = () => {
    setLineitems([])
    setReportName('')
  }

  const wrappedHandler = ({ call, error=()=>{}, errorCode, success=()=>{} }) => {
    if (!call)      { throw 'call must be provided to wrappedHandler' }
    if (!errorCode) { throw 'errorCode must be provided to wrappedHandler' }

    setLoading(true)
    call().then(r => {
      if (!r.ok) {
        throw new Error(`We're sorry, something went wrong. Please try again later. Code ${errorCode}`)
      }
      return r.json()
    }).then(success).catch((err) => {
      logg(err, 'exception in wrappedHandler')
      toast(err.toString())
      error()
    }).finally(() => {
      setLoading(false)
      refreshAdvancedReportsList()
    })
  }

  const handleSave = () => {
    wrappedHandler({
      call: () => fetch(report_id ? apiRouter.advancedReportPath({ id: report_id }) : apiRouter.advancedReportsPath(), {
          method: report_id ? 'PATCH' : 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            report: {
              name: reportName,
              lineitems,
            },
          }),
        }),
      errorCode: 'pqs',
      success: () => {
        setAdvancedReportEditModalOpen(false)
        refreshReportsList()
        toast(`${report_id ? 'Saved' : 'Created'} the report.`)
        handleClear()
      },
    })
  }

  return <F>
    <Modal
      ariaHideApp={false}
      className=" AdvancedReportEditModal BaseModal"
      isOpen={advancedReportEditModalOpen}
      onRequestClose={ () => setAdvancedReportEditModalOpen(false) }
      overlayClassName="ReportModalOverlay"
    >
      <div className='header'>
        <h5 >{ modalTitle }</h5>
        <Link to='/'><div className='close' onClick={() => {
          setAdvancedReportEditModalOpen(false) ;
        } }>&times;</div></Link>
      </div>

      <div className='modal-body d-flex flex-column'>
        <div className='container row mt-3'>
          <div className='col-md-2'></div>
          <div className='col-md-8'>
            <div className='field'>
              <label>Name</label>
              <input type='text' value={reportName} onChange={(ev) => setReportName(ev.target.value) } />
            </div>
          </div>
        </div>

        <div className='actions p-0' >
          <div className='left'>
          </div>
          <div className='right' onClick={() => {
            setShowAddLineitems(true) ;
          } } >
            <div className='btn btn-secondary'>Add Line Items</div>
          </div>
        </div>

        <div className='bordered padded mt-2 mb-2 flex-grow w-100p'>
          <div >
            <Reorder
              onReorder={(ev, prevIdx, nextIdx) => setLineitems(reorder(lineitems, prevIdx, nextIdx)) }
              reorderId={`advanced-report-${report_id}`}
              placeholder={<div />}
            >
              { lineitems.map((item, idx) => <div key={idx} className='AdvancedReportItem' >
                <div className={`bordered label flex-grow ${item.value === C.el.h3 ? 'header' : ''}`}
                     data-ubpr-code={item.value}
                >{ item.label } [ {moment(relativeToAbsolute[item.period]).format("MMM YYYY")} ({ item.period.split(' ')[0] }) ]</div>
                <div className='Btn' onClick={() => {
                  lineitems.splice( idx, 1 )
                  setLineitems(Object.assign([], lineitems))
                } } >&times;</div>
              </div>)}
            </Reorder>
            <div className='EOL' ref={(el) => setEol(el) } />
          </div>
        </div>

        <div className='actions p-0'>
          <div className='left'></div>
          <div className='right'>
            <Link to='/'>
              <input type='button' disabled={!lineitems.length || !reportName.length}
                className='Btn btn-primary' onClick={handleSave} value='Save'
              />
            </Link>
          </div>
        </div>

      </div>
    </Modal>

    <AddLineitemsModal {...{
      eol,              setEol,
      lineitems,        setLineitems,
      showAddLineitems, setShowAddLineitems,
    }} />

  </F>
}
export default AdvancedReportEditModal
